module.exports = __webpack_public_path__ + "static/media/viana-hex.a2d43a58.png";